<template>
  <div>
    <v-dialog v-model="dialog" max-width="900px">
      <template v-slot:activator="{ on }">
        <v-btn color="primary" class="mt-3 mb-2 ml-n7 mb-sm-4 light--text text-capitalize " v-on="on">
          <v-icon v-on="on">mdi mdi-cash-refund</v-icon>
          Refund
        </v-btn>
      </template>

      <v-card class="pa-6" color="pop_bg">
        <v-tabs v-model="tabs" :mobile-breakpoint="0" background-color="bg" slider-size="3" slider-color="primary">
          <v-tab class="text-caption text-sm-body-2 font-weight-medium text-capitalize">Refund</v-tab>
          <v-tab class="text-caption text-sm-body-2 font-weight-medium text-capitalize">Cancel</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tabs" class="mt-6 mb-6 mb-sm-0">
          <v-tab-item>
            <v-form @submit="expireSalesOrder()" v-model="valid" ref="form">
              <!-- <v-layout wrap>
            <v-flex xs12 sm4 md3 lg2 class="mt-n2 mt-sm-2">
              <h4 class="text-body-2 dark--text">Expire Backage By</h4>

              <v-radio-group v-model="expiredFrom" @change="onExpDateClick">
                <v-radio value="NOW" label="From Now"></v-radio>
                <v-radio value="DAY" label="Remove Days"></v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout> -->

              <v-layout wrap>
                <v-flex xs12 sm4 md3 lg2 class="mt-n2 mt-sm-2">
                  <h4 class="text-body-2 dark--text">End Date</h4>
                </v-flex>
                <v-flex xs12 sm8 md9 lg4>
                  <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        solo
                        :value="formatDate"
                        dense
                        :disabled="daysToZero"
                        append-icon="fa-calendar-alt dark--text"
                        v-bind="attrs"
                        v-on="on"
                        :rules="[daysToZero || requiredValidator('expire date')]"
                      ></v-text-field>
                    </template>

                    <v-date-picker :min="minDate" :max="maxDate" @change="onDateChange" v-model="expDate" @input="menu2 = false" color="primary"></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
              <!-- <v-layout v-if="expiredFrom == 'DAY'">
                <v-flex xs12 sm4 md3 lg2 class="mt-n2 mt-sm-2"> No of Days </v-flex>
                <v-flex xs12 sm8 md9 lg3>
                  <v-text-field
                    solo
                    dense
                    @change="recalculateEndDate()"
                    v-model="noOfDays"
                    :rules="[requiredValidator('no of days')]"
                  ></v-text-field>
                </v-flex>
              </v-layout> -->

              <v-layout wrap v-if="minDate">
                <!-- <v-flex xs12 sm4 md3 lg2 class="mt-n2 mt-sm-2">
                  <h4 class="text-body-2 dark--text">Exp Date</h4>
                </v-flex>
                <v-flex xs12 sm8 md9 lg3>
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        solo
                        :value="formatDate"
                        :disabled="true"
                        :loading="endDateLoading"
                        dense
                        append-icon="fa-calendar-alt dark--text"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :rules="[requiredValidator('expire date')]"
                      ></v-text-field>
                    </template>

                    <v-date-picker
                      :min="minDate"
                      v-model="expDate"
                      @input="menu2 = false"
                      color="primary"
                    >
                    </v-date-picker>
                  </v-menu>
                </v-flex> -->

                <v-flex xs12 sm4 md3 lg2 class="mt-n2 mt-sm-2">
                  <h4 class="text-body-2 dark--text">Refund Amount</h4>
                </v-flex>
                <v-flex xs12 sm8 md9 lg4>
                  <v-text-field solo dense type="number" v-model="refundAmount" :loading="loading" :rules="[requiredValidator('refund amount'), maxValue]"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout v-if="refundAmount > 0">
                <v-flex xs12 sm4 md3 lg2 class="mt-n2 mt-sm-2">
                  <h4 class="text-body-2 dark--text">Refund Mode</h4>
                </v-flex>
                <v-flex xs12 sm8 md9 lg4>
                  <v-select :items="refundModes" :rules="[requiredValidator('refund mode')]" v-model="refundMode" dense attach solo></v-select>
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex xs12 sm4 md3 lg2 class="mt-n2 mt-sm-2">
                  <h4 class="text-body-2 dark--text">Reason</h4>
                </v-flex>
                <v-flex xs12 sm8 md9 lg8>
                  <v-text-field solo dense v-model="reason" :rules="[requiredValidator('reason')]"></v-text-field>
                </v-flex>
              </v-layout>

              <v-card-text v-if="error" class="error--text font-weight-bold">{{ error }}</v-card-text>
              <v-card-actions justify="center">
                <v-row justify="center">
                  <v-btn color=" mx-2 error" depressed @click="close">No</v-btn>
                  <v-btn
                    color=" mx-2 success"
                    depressed
                    :loading="button_loading"
                    @click="
                      button_loading = true;
                      expireSalesOrder(salesOrder);
                    "
                    :disabled="!valid"
                    >Yes</v-btn
                  >
                </v-row>
              </v-card-actions>
            </v-form>
          </v-tab-item>
          <v-tab-item>
            <v-form @submit="expireSalesOrder()" v-model="valid" ref="form" v-if="!checkIsPlanStarted()">
              <v-layout wrap v-if="minDate">
                <v-flex xs12 sm4 md3 lg2 class="mt-n2 mt-sm-2">
                  <h4 class="text-body-2 dark--text">Refund Amount</h4>
                </v-flex>
                <v-flex xs12 sm8 md9 lg4>
                  <v-text-field solo dense type="number" v-model="refundAmount" :rules="[requiredValidator('refund amount'), maxValue]"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout v-if="refundAmount > 0">
                <v-flex xs12 sm4 md3 lg2 class="mt-n2 mt-sm-2">
                  <h4 class="text-body-2 dark--text">Refund Mode</h4>
                </v-flex>
                <v-flex xs12 sm8 md9 lg4>
                  <v-select :items="refundModes" :rules="[requiredValidator('refund mode')]" v-model="refundMode" dense attach solo></v-select>
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex xs12 sm4 md3 lg2 class="mt-n2 mt-sm-2">
                  <h4 class="text-body-2 dark--text">Reason</h4>
                </v-flex>
                <v-flex xs12 sm8 md9 lg8>
                  <v-text-field solo dense v-model="reason" :rules="[requiredValidator('reason')]"></v-text-field>
                </v-flex>
              </v-layout>

              <v-card-text v-if="error" class="error--text font-weight-bold">{{ error }}</v-card-text>
              <v-card-actions justify="center">
                <v-row justify="center">
                  <v-btn color=" mx-2 error" depressed @click="close">No</v-btn>
                  <v-btn
                    color=" mx-2 success"
                    depressed
                    :loading="button_loading"
                    @click="
                      button_loading = true;
                      expireSalesOrder(salesOrder);
                    "
                    :disabled="!valid"
                    >Yes</v-btn
                  >
                </v-row>
              </v-card-actions>
            </v-form>
            <div v-else>You cannot cancell a started plan</div>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" timeout="3000" right top :color="snackbarColor">
      {{ text }}
    </v-snackbar>
  </div>
</template>

<script>
import { DATE_FORMAT, Utils, TIME_ZONE } from "../../../utils/utils";
import { requiredValidator } from "../../../core/methods/validations";
import moment from "moment";
export default {
  props: {
    salesOrder: {
      required: true,
    },
  },
  watch: {
    refundAmount: {
      handler() {
        if (this.salesOrder.paymentId.includes("chg_")) {
          this.refundModes = ["OFFLINE", "ONLINE"];
        } else {
          this.refundModes = ["OFFLINE"];
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      menu2: false,
      maxValue: value => value <= this.salesOrder.net_price || "Max should not be above package price.",
      noOfDays: "",
      expiredFrom: "DAY",
      expDate: "",
      refundAmount: "",
      refundTax: "",
      total: "",
      requiredValidator,
      valid: true,
      isPermanentlyDelete: false,
      dialog: false,
      button_loading: false,
      show_alert: false,
      error: null,
      snackbar: false,
      snackbarColor: "",
      text: "",
      endDateLoading: false,
      reason: "",
      refundModes: ["OFFLINE"],
      refundMode: "OFFLINE",
      tabs: "",
      daysToZero: false,
      minDate: "",
      maxDate: "",
      availableNoofDays: "",
      daysToRemove: "",
      daysLeft: "",
      recalculatedDate: "",
    };
  },
  created() {
    //  let minDate = moment();
    this.onExpDateClick();
    this.maxDate = moment(new Date(parseInt(this.salesOrder.end_date))).format("YYYY-MM-DD");
    this.minDate = moment()
      .add(3, "days")
      .format("YYYY-MM-DD");

    this.availableNoofDays = this.salesOrder.package.availableChoices[0].availableNumOfDays;
    this.availableDays = this.salesOrder.package.availableChoices[0].availableNumOfDays;
    // if (moment(new Date(parseInt(this.salesOrder.start_date))) > minDate) {
    //   minDate = moment(new Date(parseInt(this.salesOrder.start_date)));
    // }
    // this.minDate = minDate.format("YYYY-MM-DD");
  },
  methods: {
    onDateChange() {
      let availableWeekDays = this.salesOrder.package.availableChoices[0].availableDays;
      let availableDaysInNum = Utils.getAvailabelWeekDaysInNumbers(availableWeekDays);
      let dayOfEndDate = moment(this.expDate).day();
      if (availableDaysInNum.includes(dayOfEndDate)) {
        this.getDaysLeft();
      } else {
        this.expDate = "";
        this.text = "This DAY is not available for this user.";
        this.snackbarColor = "error";
        this.snackbar = true;
      }
    },
    getDaysLeft() {
      this.loading = true;
      this.$apollo
        .watchQuery({
          query: require("./api/getDaysLeft.graphql"),
          variables: {
            input: {
              endDate: moment(this.expDate).format("MM-DD-YYYY"),
              subscribedPackageId: this.salesOrder._id,
              customerId: this.$route.query.customerId,
            },
          },
        })
        .refetch({
          variables: {
            input: {
              endDate: moment(this.expDate).format("MM-DD-YYYY"),
              subscribedPackageId: this.salesOrder._id,
              customerId: this.$route.query.customerId,
            },
          },
        })
        .then(data => {
          this.loading = false;
          this.daysLeft = data.data.getDaysLeft;
          if (this.daysLeft <= 0) {
            this.daysLeft = 0;
          }

          let noOfDays = this.salesOrder.package.availableChoices[0].availableNumOfDays;

          this.daysToRemove = this.availableNoofDays - this.daysLeft;
          if (this.salesOrder.net_price > 0) {
            let dayPrice = this.salesOrder.net_price / noOfDays;
            let refundAmount = dayPrice * this.daysToRemove;
            this.refundAmount = refundAmount.toFixed("3");
          }
          this.recalculateEndDate();
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        });
    },

    checkIsPlanStarted() {
      let today = moment().tz(TIME_ZONE);
      if (
        moment(new Date(parseInt(this.salesOrder.start_date))).tz(TIME_ZONE) <=
        moment(today)
          .add(2, "days")
          .tz(TIME_ZONE)
      ) {
        return true;
      }
      return false;
    },
    // onExpDateClick() {
    //   if (this.expiredFrom == "NOW") {
    //     this.expDate = moment().format("YYYY-MM-DD");
    //   } else {
    //     this.recalculateEndDate();
    //   }
    // },
    onExpDateClick() {
      if (this.expiredFrom == "NOW") {
        this.expDate = moment().format("YYYY-MM-DD");
      } else {
        //this.recalculateEndDate();
      }
    },
    getTotalNumberOfDays() {
      let availableDays = parseInt(this.salesOrder.package.availableChoices[0].availableNumOfDays);

      let currentTotalDays = availableDays;

      let noOfDays = this.noOfDays ? parseInt(this.noOfDays) : 0;

      currentTotalDays = currentTotalDays - noOfDays;

      return currentTotalDays;
    },
    recalculateEndDate() {
      let availableDays = this.salesOrder.package.availableChoices[0].availableDays;
      // debugger;
      let noOfDays = parseInt(this.availableNoofDays) - parseInt(this.daysToRemove); // this.getTotalNumberOfDays();
      //  if (noOfDays == "Error") {
      //   return;
      // }
      this.endDateLoading = true;
      this.$apollo
        .mutate({
          mutation: require("./api/reCalculateEndDate.graphql"),
          variables: {
            input: {
              start_date: moment(new Date(parseInt(this.salesOrder.start_date))).format("MM-DD-YYYY"),
              availableDays: availableDays,
              customer: this.$route.query.customerId,
              noOfDays: noOfDays,
              subscribedPackageId: this.salesOrder._id,
            },
          },
        })
        .then(data => {
          this.endDateLoading = false;
          this.recalculatedDate = moment(data.data.reCalculateEndDate, "DD-MM-YYYY").toDate();
        })
        .catch(error => {
          this.endDateLoading = false;
          console.log(error);
        });
    },

    expireSalesOrder() {
      let refundAmount = parseFloat(this.refundAmount);

      this.$apollo
        .mutate({
          mutation: require("./api/updateSalesOrderToExpire.graphql"),
          variables: {
            input: {
              customerId: this.$route.query.customerId,
              subscribedPackageId: this.salesOrder._id,
              isPermanentlyDelete: this.isPermanentlyDelete,
              net_price: refundAmount,
              basePrice: refundAmount,
              endDate: moment(this.expDate).format("YYYY-MM-DD"),
              // noOfDays: parseInt(this.noOfDays),
              noOfDays: parseInt(this.daysToRemove) - 1,
              is_expire: this.expiredFrom == "NOW" ? true : false,
              reason: this.reason,
              refundMode: this.refundMode,
              type: this.tabs == 0 ? "REFUND" : "CANCELL",
            },
          },
        })
        .then(() => {
          this.$root.$emit("updateGetCustomerById");
          this.button_loading = false;
          this.dialog = false;
          this.text = "Refund request initiated";
          this.snackbarColor = "success";
          this.snackbar = true;
        })
        .catch(error => {
          console.log(error);
          this.text = "Something went wrong";
          this.snackbarColor = "error";
          this.snackbar = true;
          this.dialog = false;
          this.button_loading = false;
        });
    },
    close() {
      this.error = null;
      this.dialog = false;
    },
  },
  computed: {
    formatDate() {
      return this.expDate ? moment(this.expDate).format(DATE_FORMAT) : "";
    },
  },
};
</script>
